import React, { useState, useEffect } from "react";
import $ from "jquery";

function ScrollYComponent() {
  const [scrollY, setScrollY] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 100 && scrollY == true) return;
    if (window.scrollY > 100) {
      return setScrollY(true);
    } else {
      return setScrollY(false);
    }
  };
  if (scrollY == false) {
    return null;
  }
  return (
    <div className={"navbar navbar-expand-lg navbar-light mx-2"}>
      <span
        className="navbar-toggler-icon"
        id="menu-toggle"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          $("#wrapper").toggleClass("toggled");

          const collapseSetup =
            document.getElementById("wrapper").className === "d-flex toggled";

          localStorage.setItem("collapse", collapseSetup);
        }}
      ></span>
    </div>
  );
}

export default ScrollYComponent;
